import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export type ChannelUrls = {
  boost_url: string;
  faq_url: string;
};

export default class ChannelUrlsConfig extends Model {
  [Type] = 'channel-urls-config' as const;

  @attr() declare channels: Record<string, ChannelUrls>;
}
